import { create } from 'zustand';

import { DEFAULT_UI_CONFIG, UIConfig } from '../types/firebaseRemoteConfig';

import { fetchAndActivateRemoteConfig, getUIConfig } from './firebaseRemoteConfig';

type FirebaseRemoteConfigStore = {
  config: UIConfig;
  loading: boolean;
  error: Error | null;
  initialized: boolean;
  fetchConfig: (force?: boolean) => Promise<void>;
  initialize: () => Promise<void>;
};

export const useFirebaseRemoteConfigStore = create<FirebaseRemoteConfigStore>((set, get) => ({
  config: DEFAULT_UI_CONFIG,
  loading: true, // Start with loading true since we'll fetch on init
  error: null,
  initialized: false,
  fetchConfig: async (force = false) => {
    try {
      set({ loading: true, error: null });

      // Fetch and activate remote config
      await fetchAndActivateRemoteConfig(force);

      // Get the UI config
      const uiConfig = getUIConfig();

      set({ config: uiConfig, loading: false });
    } catch (err) {
      const errorMessage = err instanceof Error ? err : new Error('Failed to fetch remote config');
      set({ error: errorMessage, loading: false });
    }
  },
  initialize: async () => {
    // Only initialize once
    if (get().initialized) {
      return;
    }

    set({ initialized: true });
    await get().fetchConfig(true);
  },
}));
